<template>
	<div ref="carvueRoot" class="carvue-root">
		<div class="fullscreen swiper mySwiper carvue-swiper">
			<div class="swiper-wrapper">
				<div class="swiper-slide home_slide">
					<img
						class="home_slide_wenzi"
						src="/assets/car/txt/yaoxianghaoliwenzi.png"
						alt="摇享好礼"
					/>
					<img
						class="home_slide_guang"
						src="/assets/car/bg/guang.png"
						alt=""
						aria-hidden="true"
					/>
					<div class="home_shake_stage" id="homeShakeStage" role="button" aria-label="点击或摇一摇抽奖">
						<img id="homeShakePrizeImg" class="home_shake_prize_img" alt="待摇奖" />
					</div>
					<div id="homeShakeVerifyLayer" class="home_shake_verify_layer" hidden>
						<div id="homeShakeVerifyZone" class="home_shake_verify_zone" aria-label="盖章核销"></div>
					</div>
					<button
						v-show="pwdHotspots.shake"
						type="button"
						id="homeShakePasswordHotspot"
						class="car_password_hotspot car_password_hotspot--shake"
						aria-label="密码核销"
						@mousedown.stop.prevent="openPwdDialog('shake')"
						@click.stop.prevent="openPwdDialog('shake')"
					></button>
					<div class="loading-overlay" id="loading">
						<div class="loading-box">
							<div class="loader-bars" aria-label="加载中" role="status">
								<div class="loader-bars-inner">
									<div class="loader-bars-track">
										<i
											v-for="n in loaderStripeCount"
											:key="'loader-stripe-' + n"
											class="loader-bars-stripe"
										></i>
									</div>
								</div>
							</div>
							<div class="loading-text" hidden></div>
						</div>
					</div>
				</div>
				<div class="swiper-slide log_slide">
					<img
						class="log_slide_wenzi"
						src="/assets/car/txt/hudongdakawenzi.png"
						alt="展台打卡有礼"
					/>
					<button
						v-show="pwdHotspots.log"
						type="button"
						class="car_password_hotspot car_password_hotspot--log"
						aria-label="互动打卡密码打卡"
						@mousedown.stop.prevent="openPwdDialog('log')"
						@click.stop.prevent="openPwdDialog('log')"
					></button>
					<div class="log_slide_content">
						<div class="log_slide_spacer" aria-hidden="true"></div>
						<div class="log_slide_div">
							<div class="log_slide_map_stage">
								<img
									class="log_slide_map_img"
									src="/assets/car/bg/dakatu2.png"
									alt=""
								/>
								<div class="log_slide_map_overlay">
									<div class="log_slide_div_item log_slide_item log_slide_item3" data-checkin-point="1">
										<span class="log_slide_span"><i></i><i></i><i></i><i></i><span class="log_slide_label">打卡区1</span></span>
									</div>
									<div class="log_slide_div_item log_slide_item log_slide_item4" data-checkin-point="2">
										<span class="log_slide_span"><i></i><i></i><i></i><i></i><span class="log_slide_label">打卡区2</span></span>
									</div>
								</div>
							</div>
						</div>
						<div class="log_slide_spacer" aria-hidden="true"></div>
					</div>
					<div class="log_checkin_verify_layer">
						<div class="log_checkin_verify_zone">
							<canvas class="checkinCanvas1" width="600" height="600"></canvas>
						</div>
					</div>
				</div>
				<div class="swiper-slide gift_slide">
					<img
						class="gift_slide_wenzi"
						src="/assets/car/txt/laxianghaoliwenzi.png"
						alt="拉享好礼"
					/>
					<button
						v-show="pwdHotspots.gift"
						type="button"
						class="car_password_hotspot car_password_hotspot--gift"
						aria-label="密码核销"
						@mousedown.stop.prevent="openPwdDialog('gift')"
						@click.stop.prevent="openPwdDialog('gift')"
					></button>
					<img
						class="gift_slide_guang"
						src="/assets/car/bg/guang.png"
						alt=""
						aria-hidden="true"
					/>
					<div class="gift_checkin_verify_layer">
						<img
							class="gift_checkin_status_img"
							src="/assets/car/icon/daka4-1.png"
							alt=""
							data-gift-state="locked"
						/>
						<div class="gift_checkin_verify_zone">
							<canvas class="checkinCanvas2" width="600" height="600"></canvas>
						</div>
					</div>
				</div>
				<div class="swiper-slide form_slide">
					<div class="swiper-logo">
						<img src="/assets/car/logo.png" alt="卓驭" />
					</div>
					<div class="form_slide_div_Tit">
						<h4>问卷调查</h4>
						<p class="slide_en">Questionnaire</p>
					</div>
					<div class="form_slide_div noise">
						<p class="tips">*请选择一项</p>
						<ul>
							<li><p class="form_q_row"><span class="form_q_label">Q1.</span><span class="form_q_text">您在本次卓驭车展上体验或了解的辅助驾驶功能，总体上您对其技术表现与展示效果的满意度如何？</span></p></li>
							<li class="radio-li radio-liOne"><div class="radio-btn"><i><input value="满意" type="radio" name="q1" /></i></div>满意</li>
							<li class="radio-li radio-liOne"><div class="radio-btn"><i><input value="一般" type="radio" name="q1" /></i></div>一般</li>
							<li class="radio-li radio-liOne"><div class="radio-btn"><i><input value="不满意" type="radio" name="q1" /></i></div>不满意</li>
						</ul>
						<p class="tips">*请选择一项</p>
						<ul>
							<li><p class="form_q_row"><span class="form_q_label">Q2.</span><span class="form_q_text">您对本次车展展馆布局、通道指引、休息区设置、灯光与视听环境等硬件设施的满意度如何？</span></p></li>
							<li class="radio-li radio-liTwo"><div class="radio-btn"><i><input value="满意" type="radio" name="q2" /></i></div>满意</li>
							<li class="radio-li radio-liTwo"><div class="radio-btn"><i><input value="一般" type="radio" name="q2" /></i></div>一般</li>
							<li class="radio-li radio-liTwo"><div class="radio-btn"><i><input value="不满意" type="radio" name="q2" /></i></div>不满意</li>
						</ul>
						<p class="tips">*请输入您的建议或意见</p>
						<ul class="survey-q3-block">
							<li><p class="form_q_row"><span class="form_q_label">Q3.</span><span class="form_q_text">关于卓驭品牌的产品、服务或体验，您有哪些改进建议或特别想说的意见？</span></p></li>
							<li class="input">
								<textarea rows="4" id="suggestion" name="suggestion" class="form_slide_textarea"></textarea>
							</li>
						</ul>
						<button type="button" class="form_slide_btn">提交</button>
					</div>
				</div>
			</div>
			<div class="swiper-pagaBox">
				<div class="glow-line-wrap" aria-hidden="true"><span class="glow-line-inner"></span></div>
				<div class="swiper-pagaBox-item"></div>
			</div>
		</div>
		<div class="form_slide_fiexd_Box" id="fiexd_Box" hidden aria-label="提交成功">
			<img
				class="form_slide_ending_full"
				src="/assets/car/bg/ending0626.png"
				alt="谢谢您的莅临"
			/>
		</div>
		<div class="home_check_overlay" id="homeCheck" hidden aria-hidden="true">
			<img
				class="home_check_bg_bottom"
				src="/assets/car/bg/bgb.png"
				alt=""
				aria-hidden="true"
			/>
			<div class="home_check_body">
				<img
					class="home_check_tupian"
					src="/assets/car/txt/shouyetupian.png"
					alt="欢迎莅临卓驭展台"
				/>
			</div>
			<button type="button" class="home_check_btn" id="homeCheckHotspot" aria-label="即刻探索">
				<img class="home_check_btn_img" src="/assets/car/icon/jiketansuo.png" alt="即刻探索" />
			</button>
		</div>
		<div
			v-if="pwdDialogVisible"
			class="carvue-shake-pwd-mask"
			@click.self="closePwdDialog"
		>
			<div class="carvue-shake-pwd-box">
				<input
					v-model="pwdInput"
					class="carvue-shake-pwd-input"
					type="password"
					inputmode="numeric"
					maxlength="12"
					autocomplete="off"
					placeholder="请输入密码"
					@keydown.enter.prevent="confirmPwdDialog"
				/>
				<div class="carvue-shake-pwd-actions">
					<button type="button" class="carvue-shake-pwd-btn carvue-shake-pwd-btn-cancel" @click="closePwdDialog">取消</button>
					<button type="button" class="carvue-shake-pwd-btn carvue-shake-pwd-btn-ok" @click="confirmPwdDialog">确认</button>
				</div>
			</div>
		</div>
		<div id="toastMask" class="toast-mask" aria-hidden="true"></div>
		<div id="toastBox" class="toast-box" role="alert" aria-live="polite">
			<i class="toast-icon"></i><p class="toast-msg">这里是提示文案</p>
		</div>
	</div>
</template>

<script>
import { setCarvueRoot } from './utils/dom.js'
import { loadCarSwiper, removeCarSwiperScript } from './utils/load-swiper.js'
import { parseCarvueQueryFromLocation, setCarvueRouteQuery } from './api/auth.js'
import { startCarvuePage, stopCarvuePage } from './logic/page-init.js'
import {
	PWD_HOTSPOT_KIND,
	registerCarPasswordHotspotUi,
	submitPasswordByKind,
	unregisterCarPasswordHotspotUi
} from './logic/password-hotspot.js'

const HTML_ACTIVE_CLASS = 'carvue-html-active'
const SWIPER_STYLE_LINK_ID = 'carvue-swiper-styles-link'
const CARVUE_PAGE_TITLE = '卓驭'

export default {
	name: 'CarExhibition',
	data() {
		return {
			/** 进度条条纹数量（5px 宽 + 5px 间距，对齐静态页） */
			loaderStripeCount: 32,
			pwdHotspots: {
				shake: false,
				log: false,
				gift: false
			},
			pwdDialogVisible: false,
			pwdDialogKind: '',
			pwdInput: ''
		}
	},
	async mounted() {
		document.title = CARVUE_PAGE_TITLE
		document.documentElement.classList.add(HTML_ACTIVE_CLASS)
		this.injectSwiperStyles()
		setCarvueRoot(this.$refs.carvueRoot)
		registerCarPasswordHotspotUi({
			setHotspots: (visibleMap) => {
				const m = visibleMap || {}
				this.pwdHotspots = {
					shake: !!m.shake,
					log: !!m.log,
					gift: !!m.gift
				}
			},
			openDialog: (kind) => {
				this.openPwdDialog(kind)
			},
			closeDialog: () => {
				this.closePwdDialog()
			}
		})
		setCarvueRouteQuery(parseCarvueQueryFromLocation(this.$route && this.$route.query))
		try {
			window.Swiper = await loadCarSwiper()
			await this.$nextTick()
			await startCarvuePage()
		} catch (e) {
			console.error('[carvue] 页面初始化失败', e)
		}
	},
	beforeDestroy() {
		unregisterCarPasswordHotspotUi()
		stopCarvuePage()
		setCarvueRoot(null)
		document.documentElement.classList.remove(HTML_ACTIVE_CLASS)
		this.removeSwiperStyles()
		removeCarSwiperScript()
		if (window.Swiper) {
			try {
				delete window.Swiper
			} catch (e) {
				window.Swiper = undefined
			}
		}
	},
	methods: {
		injectSwiperStyles() {
			if (document.getElementById(SWIPER_STYLE_LINK_ID)) return
			const link = document.createElement('link')
			link.id = SWIPER_STYLE_LINK_ID
			link.rel = 'stylesheet'
			link.href = require('./styles/swiper-bundle.min.css')
			document.head.appendChild(link)
		},
		removeSwiperStyles() {
			const el = document.getElementById(SWIPER_STYLE_LINK_ID)
			if (el && el.parentNode) el.parentNode.removeChild(el)
		},
		openPwdDialog(kind) {
			const key =
				kind === PWD_HOTSPOT_KIND.LOG
					? 'log'
					: kind === PWD_HOTSPOT_KIND.GIFT
						? 'gift'
						: 'shake'
			if (!this.pwdHotspots[key]) return
			this.pwdDialogKind = kind
			this.pwdInput = ''
			this.pwdDialogVisible = true
		},
		closePwdDialog() {
			if (typeof document !== 'undefined') {
				const active = document.activeElement
				if (active && active !== document.body && typeof active.blur === 'function') {
					active.blur()
				}
			}
			this.pwdDialogVisible = false
			this.pwdDialogKind = ''
			this.pwdInput = ''
			if (typeof window !== 'undefined') {
				window.scrollTo(0, 0)
			}
		},
		async confirmPwdDialog() {
			const password = this.pwdInput
			const kind = this.pwdDialogKind
			this.closePwdDialog()
			if (!kind) return
			await submitPasswordByKind(kind, password)
		}
	}
}
</script>

<!-- 仅 carvue 路由加载；样式均限定在 .carvue-root 下（rem 见 html-rem.css） -->
<style src="./styles/html-rem.css"></style>
<style src="./styles/host.css"></style>
<style src="./styles/index.scoped.css"></style>
